import { createAsyncThunk } from "@reduxjs/toolkit";
import { ThunkApiType } from "common/interfaces/common";
import { battleOfSchoolsRepository } from "modules/battleOfSchools/api/battleOfSchoolsRepository";
import { ISeason } from "modules/battleOfSchools/types/BattleOfSchoolsTypes";

export const getCurrentSeason = createAsyncThunk<ISeason, void, ThunkApiType>(
  "battleOfTheSchools/getSeason",
  (_, { rejectWithValue }) => battleOfSchoolsRepository.getCurrentSeason().catch((err) => rejectWithValue(err))
);

export const createNewSeason = createAsyncThunk<void, string | null, ThunkApiType>(
  "battleOfTheSchools/createSeason",
  (date, { rejectWithValue }) => battleOfSchoolsRepository.createNewSeason(date).catch((err) => rejectWithValue(err))
);

export const completeSeason = createAsyncThunk<void, void, ThunkApiType>(
  "battleOfTheSchools/completeSeason",
  (_, { rejectWithValue }) => battleOfSchoolsRepository.completeSeason().catch((err) => rejectWithValue(err))
);

export const resumeSeason = createAsyncThunk<void, void, ThunkApiType>(
  "battleOfTheSchools/resumeSeason",
  (_, { rejectWithValue }) => battleOfSchoolsRepository.resumeSeason().catch((err) => rejectWithValue(err))
);
